export default {
  Flowpage_CRM_Clicked_AuthorizeInForm: 'Flowpage_CRM_Clicked_AuthorizeInForm',
  Flowpage_CRM_Clicked_SalesforceCheckbox: 'Flowpage_CRM_Clicked_SalesforceCheckbox',
  Flowpage_CRM_Clicked_AuthorizeSalesforce: 'Flowpage_CRM_Clicked_AuthorizeSalesforce',
  Flowpage_CRM_Clicked_ManagePageAfterSalesforceAuth:
    'Flowpage_CRM_Clicked_ManagePageAfterSalesforceAuth',
  Flowpage_CRM_Clicked_DeleteSalesforce: 'Flowpage_CRM_Clicked_DeleteSalesforce',
  Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth: 'Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth'
}
